module.exports = __webpack_public_path__ + "public/images/star.d565bf5ccaed2689753c74bc6edaedd2.png";